import { DocumentBasylic, ErrorType } from "shared/types/types";
import React, { FC, useContext, useEffect, useState } from "react";

import AddDocumentForm from "components/AddDocumentForm";
import AddDocumentInfos from "components/AddDocumentInfos";
import DocumentIllustration from "components/DocumentIllustration/DocumentIllustration";
import ErrorScan from "components/ErrorScan";
import Loader from "shared/ui/Loader/Loader";
import Toast from "shared/ui/Toast/Toast";
import { useNavigate } from "react-router-dom";
import Modal from "shared/ui/Modal";
import Button from "shared/ui/Button";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";

import { ReactComponent as IDIcon } from "assets/img/icons/icon_ID Tracker_2.svg";
import { ReactComponent as IconPlay } from "assets/img/icons/icon_Play.svg";
import { ReactComponent as IconUpload } from "assets/img/icons/icon_Upload.svg";
import { ReactComponent as IconEdit } from "assets/img/icons/icon_Edit.svg";
import { UserContext } from "features/account";
import { useVerificationAccess } from "features/credits";
import PageHeader from "components/PageHeader";
import Alert from "shared/ui/Alert";
import BuyCreditsCard from "components/BuyCreditsCard";
import IDTrackerOverView from "./IDTrackerOverview";
import SponsorShipModal from "components/SponsorShipModal";
import { getShareIdTokenAndApplicantId } from "features/share-id";
import CheckInfoIDTracker from "features/breaches/components/CheckInfoIDTracker";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const IDTracker: FC = () => {
    const { user, userType, getMe } = useContext(UserContext);
    const [credits, setCredits] = useState(user?.credits ?? 1);
    // Accès = solde OU vérifications gratuites du mois (règle unique, features/credits).
    // On conserve l'état local `credits` : il est rafraîchi après un achat.
    const { canUse } = useVerificationAccess();
    const canVerify = credits > 0 || canUse;

    const [type, setType] = useState<string>("");
    const [isScanning, setIsScanning] = useState<boolean>(false);
    const [isScanningLoadingText, setIsScanningLoadingText] = useState<string>("Analyse en cours");
    const [isScanned, setIsScanned] = useState<boolean>(false);
    const [isConfirmed, setIsConfirmed] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [document, setDocument] = useState<DocumentBasylic>();
    const [errorType, setErrorType] = useState<ErrorType>({ status: 0, message: "" });
    const navigate = useNavigate();
    const [applicant_id, setApplicant_id] = useState<string>("");
    const [accessToken, setAccessToken] = useState<string>("");
    const [showSponsorModal, setShowSponsorModal] = useState<boolean>(false);

    const [isByVideo, setIsByVideo] = useState<boolean>(true);
    const [isManually, setIsManually] = useState<boolean>(false);
    {
        /* TODO: A commenter pour faire marcher Presentation Video*/
    }
    const [showModal, setShowModal] = useState<boolean>(true);
    {
        /* TODO: A decomenter pour faire marcher Presentation Video*/
    }
    // const [showModal, setShowModal] = useState<boolean>(false);
    const [selectedNeverShowAgain, setSelectedNeverShowAgain] = useState(() => {
        /*TODO: A decomenter pour faire marcher Presentation Video*/
        // return localStorage.getItem("IDTrackerOverview") !== "true";
        return true;
    });
    const [showOverview, setShowOverview] = useState<boolean>(() => {
        /* TODO : A décomenter pour faire marcher Video Prsentation
        return localStorage.getItem("VerifyOverview") !== "false";*/
        return true;
    });

    const getTokenFromShareId = async () => {
        // SHARE ID TOKEN
        const token = await getShareIdTokenAndApplicantId(userType ?? "");
        if (token) {
            setAccessToken(token.token);
            setApplicant_id(token.applicant_id);
            return token.token;
        }
        return null;
    };

    const handleTypeChange = (type: string) => {
        setType(type);
    };

    // reset component state
    const resetState = () => {
        setType("");
        setIsScanning(false);
        setIsScanned(false);
        setErrorMessage("");
        setDocument(undefined);
        setErrorType({ status: 0, message: "" });
    };

    useEffect(() => {
        resetState();
    }, [navigate]);

    const handleStartVerification = async (video: boolean, isManually: boolean) => {
        if (video) {
            await getTokenFromShareId();
        }
        setSelectedNeverShowAgain(false);
        localStorage.setItem("IDTrackerOverview", JSON.stringify(!selectedNeverShowAgain));
        setShowModal(false);
        setShowOverview(false);
        setIsByVideo(video);
        setIsManually(isManually);
    };


    return (
        <>
            <PageHeader
              title={"ID Tracker"}
              description={"Soyez alerté en cas de tentative"}
              notification={true}
            >
            </PageHeader>
            {showOverview && canVerify ? (
                <>
                    <IDTrackerOverView
                        showOverview={showOverview}
                        setShowOverview={setShowOverview}
                        showModal={showModal}
                        setShowModal={setShowModal}
                        selectedNeverShowAgain={selectedNeverShowAgain}
                        setSelectedNeverShowAgain={setSelectedNeverShowAgain}
                        handleStartVerification={handleStartVerification}
                    />
                </>
            ) : (
                <div className="VerifyPage content__body h-100">
                    <div className="VerifyPage__row row h-100">
                        <div className="VerifyPage__content col-sm-6">
                            {!canVerify ? (
                                <>
                                    <Alert type="error">
                                        Vous n'avez plus de vérification disponible. Veuillez en acheter.
                                    </Alert>
                                    <BuyCreditsCard
                                        showSponsorModal={showSponsorModal}
                                        setShowSponsorModal={setShowSponsorModal}
                                    />
                                </>
                            ) : !isScanning && !isScanned && errorType?.status !== 400 && !isManually ? (
                                <AddDocumentForm
                                    onChangeType={handleTypeChange}
                                    type={type}
                                    isScanning={isScanning}
                                    setIsScanning={setIsScanning}
                                    setIsScanningLoadingText={setIsScanningLoadingText}
                                    setIsScanned={setIsScanned}
                                    setErrorMessage={setErrorMessage}
                                    setDocument={setDocument}
                                    errorType={errorType}
                                    setErrorType={setErrorType}
                                    setApplicant_id={setApplicant_id}
                                    applicant_id={applicant_id}
                                    isByVideo={isByVideo}
                                    setAccessToken={setAccessToken}
                                    accessToken={accessToken}
                                />
                            ) : errorType?.status !== 400 && !isConfirmed ? (
                                <CheckInfoIDTracker
                                    onChangeType={handleTypeChange}
                                    type={type}
                                    isManually={isManually}
                                    isScanning={isScanning}
                                    document={document}
                                    setIsConfirmed={setIsConfirmed}
                                    setDocument={setDocument}
                                />
                            ) : isConfirmed ? (
                                <>
                                    <AddDocumentInfos
                                        isScanning={isScanning}
                                        document={document}
                                    />
                                </>
                            ) : (
                                <ErrorScan
                                    error={errorType?.message}
                                    resetState={resetState}
                                />
                            )}
                        </div>

                          <div className="VerifyPage__illu col-sm-6 center">
                              <div>
                                  {!isMobile && (
                                    <>
                                        <h1 className="VerifyPage__title text-center mb-4">Ajouter une pièce
                                            d'identité</h1>
                                        <DocumentIllustration type={type} />
                                    </>
                                  )}
                                  {isScanning && <Loader text={isScanningLoadingText} />}
                              </div>
                          </div>


                    </div>
                    {errorMessage && (
                      <Toast
                        type="error"
                        message={errorMessage}
                      />
                    )}
                </div>
            )}
            {showModal && canVerify && (
              <Modal
                onClose={() => setShowModal(false)}
                    isOpen={showModal}
                    title="Vérifier un document"
                    infoModal
                    type="info">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-center gap-05">
                        <p>J’effectue l'ajout du document par :</p>
                        <div className="d-flex gap-1 flex-wrap justify-content-center align-items-center">
                            <Button
                                label="Vidéo"
                                style={Button_Style.OUTLINED}
                                onClick={() => handleStartVerification(true, false)}
                                icon={<IconPlay />}
                                type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                            />
                            <Button
                                label="Photo"
                                style={Button_Style.OUTLINED}
                                onClick={() => handleStartVerification(false, false)}
                                icon={<IconUpload />}
                                type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                            />
                            <Button
                              label="Manuellement"
                              style={Button_Style.OUTLINED}
                              onClick={() => handleStartVerification(false, true)}
                              icon={<IconEdit />}
                              type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                            />
                        </div>
                    </div>
                </Modal>
            )}

            {showSponsorModal && (
                <SponsorShipModal
                    isOpen={showSponsorModal}
                    onClose={() => setShowSponsorModal(false)}
                />
            )}
            
        </>
    );
};
export default IDTracker;
